<template>
  <div class="w-screen h-screen flex justify-center items-center">
    <div class="bg-[#2C3795] w-full h-full absolute overflow-hidden">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-full h-full"
        width="1920"
        height="969"
        fill="none"
      >
        <path
          d="M1945.1 680.002C1929.01 654.506 1907.33 633.103 1881.75 617.456C1856.17 601.809 1827.38 592.339 1797.61 589.776H1780.19C1739.98 591.775 1701.24 605.725 1668.82 629.888C1636.39 654.051 1611.72 687.351 1597.88 725.631C1563.5 822.376 1507.4 909.715 1434 980.756C1355.22 1057.69 1259 1113.88 1153.78 1144.38C1048.55 1174.89 937.546 1178.78 830.491 1155.71C723.437 1132.65 623.607 1083.34 539.762 1012.11C455.917 940.874 390.62 849.896 349.597 747.152C308.574 644.408 293.081 533.036 304.477 422.816C315.872 312.596 353.806 206.893 414.953 114.978C476.101 23.0639 558.593 -52.2527 655.19 -104.361C751.787 -156.47 859.537 -183.779 968.988 -183.893C1010.21 -183.675 1051.33 -179.856 1091.9 -172.483C1126.75 -167.245 1159.85 -153.576 1188.38 -132.634C1216.9 -111.692 1240.02 -84.0944 1255.78 -52.181C1274.22 6.93298 1226.07 72.2678 1181.01 117.9L1103.17 197.757C1061.26 177.604 1015.38 167.321 968.988 167.681C900.024 167.461 832.844 189.836 777.476 231.464C722.107 273.091 681.522 331.738 661.785 398.645C642.048 465.552 644.214 537.129 667.965 602.686C691.715 668.242 735.773 724.256 793.558 762.369C851.342 800.482 919.753 818.647 988.573 814.148C1057.39 809.648 1122.93 782.732 1175.39 737.411C1227.86 692.089 1264.43 630.798 1279.66 562.693C1294.89 494.589 1287.95 423.324 1259.88 359.542L1669.58 -55.2921C1700.65 -92.5182 1716.38 -140.422 1713.52 -189.077C1710.66 -237.732 1689.42 -283.409 1654.21 -316.64C1463.85 -486.376 1218.54 -579.383 964.893 -577.984C792.422 -578.596 622.392 -536.713 469.473 -455.948C316.554 -375.183 185.336 -257.96 87.1397 -114.394C-11.0568 29.1722 -73.2834 194.771 -94.173 368.119C-115.063 541.468 -93.986 717.362 -32.7644 880.624C28.4573 1043.89 127.985 1189.62 257.237 1305.24C386.49 1420.87 541.584 1502.92 709.14 1544.32C876.696 1585.72 1051.68 1585.21 1219.01 1542.86C1386.33 1500.51 1540.97 1417.58 1669.58 1301.22L1714.64 1258.69C1826 1145.89 1911.34 1009.54 1964.56 859.419C1975.34 830.044 1979.19 798.526 1975.81 767.376C1972.43 736.227 1961.92 706.307 1945.1 680.002Z"
          fill="#151A47"
        />
      </svg>
    </div>

    <div
      class="bg-white rounded-2xl shadow-md px-24 py-24 lg:w-[656px] relative flex flex-col gap-12"
    >
      <div class="flex flex-col items-center gap-4">
        <EvidenceLogo class="mb-4 w-12 h-12 text-primary-500" />
        <div class="flex flex-col items-center gap-2">
          <p class="text-xl leading-5 font-bold text-blue-900 tracking-tighter">
            Hello again!
          </p>
          <p class="text-base /70 text-slate-500">
            Please login using your account credentials.
          </p>
        </div>
      </div>
      <div class="space-y-6">
        <div class="space-y-6">
          <TextInput
            id="email"
            ref="emailInput"
            v-model="email"
            label="Email"
            type="email"
            placeholder="Email"
            :rules="[
              (v) => !!v || 'Email is required',
              (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
            ]"
            @keyup.enter="login"
          />

          <div class="relative">
            <RouterLink
              to="/forgot-password"
              class="text-blue-800 font-semibold text-xs absolute right-2"
              >Forgot password ?</RouterLink
            >
            <TextInput
              id="password"
              ref="passwordInput"
              v-model="password"
              label="Password"
              type="password"
              placeholder="******************"
              :rules="[(v) => !!v || 'Password is required']"
              @keyup.enter="login"
            />
          </div>
        </div>
        <div class="flex items-center gap-2">
          <input
            id="rememberMe"
            type="checkbox"
            class="w-4.5 h-4.5 font-semibold border-gray-300 rounded-sm accent-primary"
          />
          <label
            for="rememberMe"
            class="text-slate-700 text-xs font-medium leading-4"
          >
            Remember Me
          </label>
        </div>
      </div>

      <div class="flex items-center">
        <button
          class="bg-primary-500 hover-bg-blue-dark text-white font-medium py-4 px-6 rounded-lg flex items-center gap-1 w-full justify-center text-base"
          type="button"
          :class="{ 'opacity-50': loading.isLoading.value }"
          :disabled="loading.isLoading.value"
          @click="login"
        >
          Sign in
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import TextInput from '@app/components/Global/Inputs/TextInput.vue'
import { UsersService } from '@core/application/users.service'
import useSnackbar from '@app/composables/use-snackbar'
import { SnackbarState } from '@app/types'
import { injectStrict } from '@app/utils/injectStrict'
import { AuthKey, UsersServiceKey } from '@app/injectionKeys'
import useLoading from '@app/composables/use-loading'
import useWebExtension from '@app/composables/useWebExtension'
import EvidenceLogo from '@app/components/Icons/EvidenceLogo.vue'

const usersService: UsersService = injectStrict(UsersServiceKey)
const email = ref()
const password = ref()
const snackbar = useSnackbar()
const loading = useLoading()

const emailInput = ref<InstanceType<typeof TextInput>>()
const passwordInput = ref<InstanceType<typeof TextInput>>()

const { loginExtension } = useWebExtension()
const { getRecoveryLink } = injectStrict(AuthKey)

async function login() {
  const isEmailValid = emailInput.value?.validate()
  const isPasswordValid = passwordInput.value?.validate()
  if (!isEmailValid || !isPasswordValid) return
  loading.start()
  try {
    await usersService.login(email.value.trim(), password.value.trim())
    const recoveryLink = await getRecoveryLink()
    await loginExtension(recoveryLink).catch(() => null)
    window.location.reload()
  } catch (e) {
    loading.stop()
    snackbar.show(SnackbarState.ERROR, 'Login failed')
    throw e
  }
}
</script>
